module.exports = __webpack_public_path__ + "static/Danzza-Regular-db82df01f4ba38fd39e0b960b0b848aa.woff";